import { BellAlertIcon, PencilSquareIcon, TrashIcon, UserPlusIcon } from '@heroicons/react/24/solid';
import {
	Button,
	Chip,
	Tooltip,
	Typography
} from '@material-tailwind/react';
import { useState } from 'react';
import ConfirmOrCancel from './Modals/ConfirmOrCancel';

// TODO types
interface Props {
	users,
	setSelectedUser,
	onDeleteUser: (userToBeDeleted: any) => Promise<void>,
	invites,
	canInviteUsers,
	onBumpInvite,
	onDeleteInvite,
}

// TODO something odd with the rendering... renders 3 times
const UserList = ({ users, setSelectedUser, onDeleteUser, invites, canInviteUsers, onBumpInvite, onDeleteInvite }: Props) => {
	const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
	const [deleteUserModalTitle, setDeleteUserModalTitle] = useState('');
	const [onConfirmUserDeleteUserModal, setOnConfirmUserDeleteModal] = useState(() => () => { });

	return (
		<div className="overflow-auto mx-8 mb-4">
			{canInviteUsers && (
				<Button
					className="capitalize leading-none text-sm flex items-center float-right mt-2"
					size="sm"
					color="light-green"
					onClick={() => {
						setSelectedUser({ userName: '' });
					}}
				>
					<UserPlusIcon className="w-6" />
					&nbsp; Invite User
				</Button>
			)}
			<div className="p-4 flex gap-x-4 items-center">
				<Typography variant="h5">Manage Users</Typography>
			</div>
			<table className="table-fixed w-full max-w-full text-left">
				<thead>
					<tr>
						<th className="border-y border-blue-gray-100 bg-blue-gray-50/50 px-4 py-2">
							Name
						</th>
						<th className="border-y border-blue-gray-100 bg-blue-gray-50/50 px-4 py-2">
							Email
						</th>
						<th className="w-[50%] border-y border-blue-gray-100 bg-blue-gray-50/50 px-4 py-2">
							Roles
						</th>
					</tr>
				</thead>
				<tbody>
					{users.map((user) => (
						<UserRow
							user={user}
							onSelectUser={() => {
								setSelectedUser(user);
							}}
							onDeleteUser={() => {
								setShowDeleteUserModal(true);
								setOnConfirmUserDeleteModal(() => async () => await onDeleteUser(user));
								setDeleteUserModalTitle(`Confirm deleting user ${user.userName}`);
							}}
						/>
					))}
					{invites.map((invite) => (
						<InviteRow
							invite={invite}
							onBumpInvite={onBumpInvite}
							onDeleteInvite={onDeleteInvite}
						/>
					))}
				</tbody>
			</table>
			<ConfirmOrCancel
				open={showDeleteUserModal}
				toggleOpen={() => setShowDeleteUserModal(!showDeleteUserModal)}
				onConfirm={onConfirmUserDeleteUserModal}
				title={deleteUserModalTitle}
			/>
		</div>
	);
};

const UserRow = ({ user, onSelectUser = () => { }, onDeleteUser = (user): any => Promise.resolve({}) }) => {
	return (
		<tr key={user.email}>
			<td className="border-y px-4 py-2">{user.userName}</td>
			<td className="border-y px-4 py-2">{user.email}</td>
			<td className="border-y px-4 py-2">
				<div className="flex justify-between items-center">
					{
						<div className="flex flex-wrap justify-left">
							{user.roleNames?.map((roleName) => (
								<Chip
									key={roleName}
									value={roleName}
									className="w-[fit-content] m-1"
								/>
							))}
						</div>
					}
					<div className="flex">
						<Tooltip content="Edit User">
							<button
								className="hover:bg-gray-300 h-12 font-bold py-2 px-4 rounded"
								onClick={onSelectUser}
							>
								<PencilSquareIcon className="h-6 w-6" />
							</button>
						</Tooltip>
						<Tooltip content="Delete User">
							<button
								className="hover:bg-gray-300 h-12 font-bold py-2 px-4 rounded"
								onClick={() => {
									onDeleteUser(user);
								}}
							>
								<TrashIcon className="h-6 w-6" />
							</button>
						</Tooltip>
					</div>
				</div>
			</td>
		</tr>
	);
}

const InviteRow = ({ invite, onBumpInvite, onDeleteInvite }) => {
	return (
		<tr key={invite.email}>
			<td className="border-y px-4 py-2">
				<div className="flex items-center gap-x-2">
					{invite.email}
					{<Chip
						value={`Invite: ${invite.state}`}
						className="w-[fit-content] m-1"
						color="amber"
						variant='ghost'
					/>}
				</div>
			</td>
			<td className="border-y px-4 py-2">{invite.email}</td>
			<td className="border-y px-4 py-2">
				<div className="flex justify-between items-center">
					{
						<div className="flex flex-wrap justify-left">
							{invite.roleNames?.map((roleName) => (
								<Chip
									key={roleName}
									value={roleName}
									className="w-[fit-content] m-1"
								/>
							))}
						</div>
					}
					<div className="flex">
						<Tooltip content="Bump Invite">
							<button
								className="hover:bg-gray-300 h-12 font-bold py-2 px-4 rounded"
								onClick={() => onBumpInvite(invite)}
							>
								<BellAlertIcon className="h-6 w-6" />
							</button>
						</Tooltip>
						<Tooltip content="Delete Invite">
							<button
								className="hover:bg-gray-300 h-12 font-bold py-2 px-4 rounded"
								onClick={() => {
									onDeleteInvite(invite);
								}}
							>
								<TrashIcon className="h-6 w-6" />
							</button>
						</Tooltip>
					</div>
				</div>
			</td>
		</tr>
	);
}

export default UserList;
